var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDicesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc400;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infos_icons",
    "data-name": "infos icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dices"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profil_icons",
    "data-name": "profil icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dices-2",
    "data-name": "dices",
    className: "cls-1",
    d: "M81.56,42.55H67.78a9.57,9.57,0,0,1-2.11,10.38L50,68.68v5.37a5.54,5.54,0,0,0,5.45,5.63H81.56a5.54,5.54,0,0,0,5.54-5.54h0v-26a5.54,5.54,0,0,0-5.47-5.59h-.07ZM68.36,63.88a2.73,2.73,0,1,1,.18,0ZM63.17,42.31,42.88,22a5.69,5.69,0,0,0-8,0L14.55,42.31a5.67,5.67,0,0,0,0,8h0L34.88,70.57a5.67,5.67,0,0,0,8,0h0L63.21,50.31a5.66,5.66,0,0,0,0-8h0ZM24,49.06a2.82,2.82,0,1,1,2.76-2.88h0v.12A2.76,2.76,0,0,1,24,49.08h0ZM38.88,63.88a2.77,2.77,0,1,1,2.77-2.77h0A2.81,2.81,0,0,1,38.88,63.88Zm0-14.82a2.82,2.82,0,1,1,2.77-2.87h0v.12A2.82,2.82,0,0,1,38.88,49.06Zm0-14.86a2.77,2.77,0,1,1,2.77-2.77h0A2.82,2.82,0,0,1,38.88,34.2ZM53.7,49.06a2.82,2.82,0,1,1,2.78-2.86v.11A2.77,2.77,0,0,1,53.7,49.06Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 100,
    height: 100
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDicesIcon);
export default __webpack_public_path__ + "static/media/dicesIcon.441afaefcc69f8a2bfcf0a40d3f51cd7.svg";
export { ForwardRef as ReactComponent };